<script>
import Page from '@/views/config/role/index.vue';
export default Page;
</script>
